export default "__VITE_ASSET__CWgZdGVX__$_?inline__"